import client from '../request'

const getAll = `/recording_results`

const get = (id) => {
  return `/recording_results/${id}`
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data?.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}
const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const remove = (id) => {
  return client.delete(`/recording_results/${id}`)
}

const RecordingResultService = {
  getAll,
  get,
  toRow,
  remove,
  toPaginate
}

export default RecordingResultService
